import { all } from 'redux-saga/effects';
import { imageApprovalSaga, ingredientApprovalSaga, jobsSaga, ordersSaga, proManagementSaga, adminProductsSaga, varietyApprovalSaga } from './admin';
import authSaga from './auth/saga';
import { articleSaga, articlesSaga, categoriesSaga, relatedArticlesSaga, tagsSaga } from './blog';
import { brevoContactsSaga, brevoFoldersSaga, brevoListSaga, brevoTemplatesSaga, brevoUtilitySaga } from './brevo';
import { countriesSaga, cultivationTipsSaga, funFactSaga, globalStatsSaga, membershipsPeriodsSaga, mushroomsSaga, newsSaga, specialtiesSaga, trendingDataSaga, uielementsSaga } from './resources';
import { cartSaga, checkoutSaga, couponsSaga, invoicesSaga, membershipsSaga, pricesSaga, productsSaga, userOrdersSaga } from './shop';
import sporexpertUserSaga from './sporexpertuser/saga';
import { calcSaga, quizSaga } from './tools';
import { organizationSaga, noteSaga, recipeSaga, spawnSaga, configSaga, mushroomSaga, batchSaga, stageSaga, monitoringSaga, sensorSaga, sensorManagementSaga, apiKeySaga, labelSaga } from './slices/mycolab';
import { alertsSaga } from './slices/mycore';
import archivesSaga from './mycore/archives/saga';
import communitySaga from './mycore/community/saga';
import { taskAlertsSaga } from './mycore/taskAlerts';
import ingredientsSaga from './mycore/ingredients/saga';
import { messagesSaga } from './messages';
import { gamificationSaga } from './gamification';

export default function* rootSaga(getState) {
    yield all([
        authSaga(),
        sporexpertUserSaga(),

        // admin
        imageApprovalSaga(),
        ingredientApprovalSaga(),
        jobsSaga(),
        ordersSaga(),
        proManagementSaga(),
        adminProductsSaga(),
        varietyApprovalSaga(),

        // resource
        newsSaga(),
        funFactSaga(),
        cultivationTipsSaga(),
        globalStatsSaga(),
        trendingDataSaga(),
        countriesSaga(),
        specialtiesSaga(),
        membershipsPeriodsSaga(),
        uielementsSaga(),
        mushroomsSaga(),

        // brevo
        brevoListSaga(),
        brevoFoldersSaga(),
        brevoUtilitySaga(),
        brevoContactsSaga(),
        brevoTemplatesSaga(),

        // blog
        tagsSaga(),
        articleSaga(),
        articlesSaga(),
        categoriesSaga(),
        relatedArticlesSaga(),

        // shop
        cartSaga(),
        pricesSaga(),
        couponsSaga(),
        invoicesSaga(),
        membershipsSaga(),
        productsSaga(),
        checkoutSaga(),
        userOrdersSaga(),

        // tools
        calcSaga(),
        quizSaga(),

        // mycolab
        organizationSaga(),
        noteSaga(),
        recipeSaga(),
        spawnSaga(),
        configSaga(),
        mushroomSaga(),
        batchSaga(),
        stageSaga(),
        monitoringSaga(),
        sensorSaga(),
        sensorManagementSaga(),
        apiKeySaga(),
        labelSaga(),
        alertsSaga(),
        archivesSaga(),
        communitySaga(),
        taskAlertsSaga(),
        ingredientsSaga(),

        // messages
        messagesSaga(),

        // gamification
        gamificationSaga(),

    ]);
}
